<script setup>
import CollectionsGrid from '@pages/home/CollectionsGrid.vue';
import InspirationsGrid from '@pages/home/InspirationsGrid.vue';
import Footer from '@pages/home/Footer.vue';

import { useLinks } from '../links';

const { getLink } = useLinks();

</script>

<template>
    <div class="w-100 py-4">
        <div class="container margin-80">
            <div class="d-flex gap-5 gap-lg-3 flex-column-reverse flex-lg-row justify-content-between align-items-center w-100 main-margin">
                <div>
                    <a :href="getLink('/')" class="d-flex align-items-center gap-2">
                        <img src="/images/logo-savicki-no-claim.svg" alt="logo" height="28" class="" loading="eager" />
                    </a>
                </div>

                <div class="d-flex gap-3">
                    <a :href="getLink('kontakt')" class="btn btn-outline-primary rounded-0 py-2">{{ $t('footer.link5') }}</a>
                    <a :href="getLink('/')" class="btn btn-primary rounded-0 py-2">{{ $t('global.comeback-to-site') }}</a>
                </div>
            </div>


            <div class="text-center margin-64">
                <h1 class="mb-4 font-serif" v-html="$t('home-new.text1')"></h1>

                <p class="fs-4 mb-4" v-html="$t('home-new.text2')">
                </p>

                <div class="d-flex gap-3 justify-content-center">
                    <a href="/configurator/2229" class="btn btn-outline-primary rounded-0 py-2">{{ $t('home-new.text3') }}</a>
                    <a href="#beginning" class="btn btn-primary rounded-0 py-2">{{ $t('home-new.text4') }}</a>
                </div>
            </div>

            <div class="d-flex justify-content-center margin-64">
                <img src="/images/configurator-desktop.png" alt="" class="img-fluid d-none d-md-block">
                <img src="/images/configurator-mobile.png" alt="" class="img-fluid d-block d-md-none">
            </div>

            <div id="beginning" class="text-center">
                <h2 class="mb-4 font-serif">
                    {{ $t('home-new.text5') }}
                </h2>

                <p class="fs-6 mb-4" v-html="$t('home-new.text6')">
                </p>

                <CollectionsGrid />
            </div>

            <hr class="my-64" />

            <!-- <div class="text-center">
                <h2 class="mb-4 font-serif">
                    {{ $t('home-new.text7') }}
                </h2>

                <p class="fs-6 mb-4" v-html="$t('home-new.text8')">
                </p>

                <InspirationsGrid />
            </div>

            <hr class="my-64"  /> -->
        </div>

        <Footer />
    </div>

    <!-- <div
        class="container mx-auto text-center home-container align-items-center justify-content-center p-3"
    >
        <div class="mx-auto mb-5" style="max-width: 500px">
            <p class="fs-8">
                <a :href="comebackUrl">{{ $t('global.comeback-to-site') }}</a>
            </p>

            <h1 class="mb-4 fs-4 fw-normal">
                {{ $t('home.text1') }}
            </h1>

            <h4 class="mb-4">
                {{ $t('home.text2') }}
            </h4>

            <p class="mb-4">
                {{
                    $t('home.text3', {
                        amount: 6,
                    })
                }}
            </p>

            <p>
                {{ $t('home.text4') }}
            </p>
        </div>

        <div class="mb-5">
            <CollectionsGrid />
        </div>
    </div> -->
</template>

<style scoped lang="scss">

.main-margin {
    margin-bottom: 40px;

    @media (min-width: 992px) {
        margin-bottom: 128px;
    }
}

.margin-64 {
    margin-bottom: 64px;
}

.margin-80 {
    margin-bottom: 80px;
}

</style>